
export default {
    name: 'BankAddEmptyCard',
    props: {
        myClass: {
            type: String,
            default: '',
        },
        myStyle: {
            type: Object,
            default: () => {},
        },
    },
}
